import { render, staticRenderFns } from "./AddInstagram.vue?vue&type=template&id=5dbd3bff&scoped=true&"
import script from "./AddInstagram.vue?vue&type=script&lang=js&"
export * from "./AddInstagram.vue?vue&type=script&lang=js&"
import style0 from "./AddInstagram.vue?vue&type=style&index=0&id=5dbd3bff&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbd3bff",
  null
  
)

export default component.exports